// Shared animation variants so entrance motion feels consistent across
// pages instead of every component inventing its own timing curve.
// One staggered reveal per page on first paint -- nothing loops or
// replays on scroll, and hover/tap feedback only answers direct interaction.

export const EASE = [0.16, 1, 0.3, 1];

export const staggerContainer = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.06, delayChildren: 0.04 },
  },
};

export const fadeInUp = {
  hidden: { opacity: 0, y: 16 },
  show: { opacity: 1, y: 0, transition: { duration: 0.45, ease: EASE } },
};

export const fadeIn = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 0.4, ease: EASE } },
};

export const scaleIn = {
  hidden: { opacity: 0, scale: 0.94 },
  show: { opacity: 1, scale: 1, transition: { duration: 0.35, ease: EASE } },
};

export const hoverLift = {
  whileHover: { y: -4, transition: { duration: 0.2, ease: EASE } },
  whileTap: { y: 0, scale: 0.99 },
};

export const pageTransition = {
  initial: { opacity: 0, y: 10 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.35, ease: EASE } },
  exit: { opacity: 0, y: -8, transition: { duration: 0.2, ease: EASE } },
};
